// LandingPage.js
import PageTop from './landing_page/PageTop';
import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './LandingPage.css';
import TestimonialCarousel from './landing_page/Testimonials';
import { useAuth } from './AuthContext';

function LandingPage() {


    const location = useLocation();
    const navigate = useNavigate();
    var { login} = useAuth(); 
    const [totalUsers, setTotalUsers] = useState(null);
    const [totalInteractions, setTotalInteractions] = useState(null);
    const [newMembersToday, setNewMembersToday] = useState(null);
    const [loading, setLoading] = useState(true); // Start in loading state
    const [error, setError] = useState(null);
    const [isProcessingCardData, setIsProcessingCardData] = useState(false); 
    
    //user login state management
    const [isProcessingUserData, setIsProcessingUserData] = useState(false); 


    useEffect(() => {
        const fetchData = async () => {
            setLoading(true); 
            setError(null);

            const fetchAndParse = async (endpoint) => {
                
                //Fetch data from the API endpoint (dev)
                const response = await fetch(`/api/${endpoint}`);
                // Fetch data from the API endpoint (p[roduction)])
                //const response = await fetch(`/api/${endpoint}`); 
                //console.log(`Response for ${endpoint}:`, response);

                if (!response.ok) {
                    let errorMessage = `HTTP error fetching ${endpoint}! status: ${response.status}`;
                    let errorDetails = `Status: ${response.status}`;
                    try {
                        const errorData = await response.json(); 
                        errorDetails = JSON.stringify(errorData);
                        console.error(`Server Error Response (${endpoint}):`, errorData);
                    } catch (jsonError) {
                        try {
                            const errorText = await response.text();
                            errorDetails = errorText;
                            console.error(`Server Error Response (${endpoint}):`, errorText);
                        } catch (textError) {
                            errorDetails += `, Could not read error response body.`;
                            console.error(`Server Error (${endpoint}). Could not read response body`);
                        }
                    }
                    errorMessage += `, Error: ${errorDetails}`;
                    // Throw an error object to include details if needed later
                    const error = new Error(errorMessage);
                    error.details = errorDetails; // Attach details if needed
                    error.status = response.status;
                    throw error;
                }
                const jsonData = await response.json();
                //console.log(`JSON data for ${endpoint}:`, jsonData); // Log the parsed JSON data
                
                return jsonData; // Return the parsed data
            };

            try {
                if (isProcessingCardData === false) {
                    setIsProcessingCardData(true); 
                    const results = await Promise.all([
                        fetchAndParse('get_user_count'),
                        fetchAndParse('get_bot_interactions'),
                        fetchAndParse('get_new_members_today')
                    ]);

                    // Process results after all promises have resolved successfully
                    const [userCountData, botInteractionsData, newMembersData] = results;

                    // Extract data using the expected keys
                    // Handle cases where the API might not return data or returns an empty array
                    setTotalUsers(userCountData?.[0]?.['count(user_id)'] ?? 0);
                    setTotalInteractions(botInteractionsData?.[0]?.['SUM(bot_mention_count)'] ?? 0);
                    setNewMembersToday(newMembersData?.[0]?.['count(user_id)'] ?? 0);
                }
            } catch (err) {
                console.error("Fetch error:", err);
                setError(`Failed to load some data. Please try again later. (Details: ${err.message})`);
            } finally {
                // This block runs whether the try succeeded or failed
                setLoading(false); // Stop loading indicator
            }
        };

        fetchData();
    }, []); 


    useEffect(() => {
        // Create URLSearchParams object from the query string
        const queryParams = new URLSearchParams(location.search);

        // Get the 'code' parameter, if it exists
        const code = queryParams.get('code');

        if(code && isProcessingUserData === false) {
            console.log("Code found in URL:", code);
            setIsProcessingUserData(true);
            
            //http://localhost:5000/api/auth/discord/callback (dev)
            ///api/auth/discord/callback (prod)
            fetch('http://localhost:5000/api/auth/discord/callback', { // Your backend API route
                method: 'POST', // Use POST method
                headers: {
                    'Content-Type': 'application/json',
                },  
                body: JSON.stringify({ code: code }),
            }).then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json(); 
            }).then(data => {

                if (data) {
                    login(data.data);

                navigate(location.pathname, { replace: true }); // Removes query string\
                }
            }).catch(err => {
                    console.error("Login process failed:", err);

                    navigate(location.pathname, { replace: true });
                });
        }
    }, [location.search, navigate, location.pathname]);

    const renderCardData = (data, isLocaleString = true) => {
        if (loading) {
            return 'Loading...';
        }
        if (data === null || data === undefined) {
            return 'N/A';
        }
        return isLocaleString ? data.toLocaleString() : data;
    };

    
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            padding: '0 20px',
            marginLeft: '5%',
            marginRight: '5%'
        }}>
            <PageTop />

            <TestimonialCarousel />

             {/* Display a general error message if fetching failed */}
             {error && !loading && <p style={{ color: 'red', textAlign: 'center' }}>Error loading data: {error}</p>}

            {/* Render the container and cards regardless of loading state */}
            <div className="container">
                {/* Card 1: Total Users */}
                <div className="card">
                    <div className="card-header"><strong>Total Users</strong></div>
                    {/* Show 'Loading...' or the actual data */}
                    <div className="card-data">{renderCardData(totalUsers)}</div>
                </div>

                {/* Card 2: Total Bot Interactions */}
                <div className="card">
                    <div className="card-header"><strong>Total Bot Interactions</strong></div>
                    {/* Show 'Loading...' or the actual data */}
                    <div className="card-data">{renderCardData(totalInteractions)}</div>
                </div>

                {/* Card 3: New Members Today */}
                <div className="card">
                    <div className="card-header"><strong>New Members Today</strong></div>
                    {/* Show 'Loading...' or the actual data (no toLocaleString needed usually) */}
                    <div className="card-data">{renderCardData(newMembersToday, false)}</div>
                </div>
            </div>
        </div>
    );
}

export default LandingPage;